import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CalendarModel} from '../../../models/api/calendarModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

/*
 * Reducer.
 */

const calendarsUpdatedReducer = createResourcesUpdatedReducer('calendars', (calendar) => calendar.id);

export function calendarsReducer(
  state: ResourceMap<CalendarModel>,
  action: AppAction,
): ResourceMap<CalendarModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return calendarsUpdatedReducer(state, action);

    default:
      return state;
  }
}
